import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { fetchPresignedDownloadUrl } from '@/integrations/agreements/client';
import { getEvidenceDownloadFilename, type EvidenceSide } from '@/utils/evidenceMediaKind';

interface EvidenceDownloadParams {
  /** URL que o modal já usa para tocar a evidência. */
  url: string;
  collectId: string;
  side: EvidenceSide;
}

/**
 * Baixa a evidência (antes ou depois) da coleta.
 *
 * A URL do player abre o vídeo: o bucket não tem CORS, então `<a download>` é ignorado e
 * `fetch` + blob é bloqueado. O agreements reassina a mesma URL com `attachment`, e navegar
 * até ela faz o navegador salvar o arquivo sem sair da página.
 */
export function useEvidenceDownload() {
  return useMutation({
    mutationFn: ({ url, collectId, side }: EvidenceDownloadParams) =>
      fetchPresignedDownloadUrl(url, getEvidenceDownloadFilename(url, collectId, side)),
    onSuccess: (downloadUrl) => {
      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.click();
    },
    onError: () => {
      toast.error('Não foi possível baixar a evidência. Tente novamente.');
    },
  });
}
